import ForgotPasswordForm from '@/components/Forms/ForgotPasswordForm';
import { useForgotPassword } from '@/query/queries/user/useForgotPassword';
import './index.scss';

const ForgotPassword = () => {
  const { mutateAsync: forgotPassword } = useForgotPassword();

  const onSubmit = async ({ email }, { resetForm, setSubmitting }) => {
    try {
      await forgotPassword({ email });
      resetForm();
    } catch {
      // The message is shown by the mutation's onError
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="forgot-password">
      <div className="forgot-password__inner">
        <ForgotPasswordForm onSubmit={onSubmit} />
      </div>
    </div>
  );
};

export default ForgotPassword;
